<pp-grid [ppOptions]="gridOptions">
  <ng-container title>
    <div class="settingsSection__title">
      {{ 'my_sites' | ppTranslate }}

      <section class="settingsSection__options">
        <pp-search-box
          class="settingsSection__searchBox"
          [ppPlaceholder]="'search_sites' | ppTranslate"
          (ppAction)="setKeyword($event)"
        ></pp-search-box>

        <button class="settingsSection__more" [id]="buttonId" (click)="toggleDropdown()">
          <pp-icon
            [ppSrc]="EIconPath.ICON_MISC_3_DOTS_MENU_24"
            ppClass="setSize24"
            ppColor="grey-900"
          ></pp-icon>
        </button>
      </section>
    </div>
  </ng-container>

  <ng-container body>
    <pp-user-settings-table-container
      body
      [ppWorkspaces]="filteredWorkspaces"
    ></pp-user-settings-table-container>
  </ng-container>

  @if (!filteredWorkspaces && filteredWorkspaces.length === 0) {
    <div
      class="settingsSection__no-content"
      >
      {{ 'no_sites_found' | ppTranslate }}
    </div>
  }
</pp-grid>
